
import { useState, Suspense } from 'react';
import AdminSidebar from '../components/AdminSidebar';
import AdminHeader from '../components/AdminHeader';
import BannersGrid from './components/BannersGrid';
import HeroEditor from './components/HeroEditor';

export default function AdminBannersPage() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('banners');

  return (
    <div className="min-h-screen bg-[#F8F9FA] font-sans">
      {/* Mobile Sidebar Overlay */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setIsSidebarOpen(false)}
        ></div>
      )}

      <AdminSidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

      <div className="lg:ml-64 min-h-screen">
        <AdminHeader onMenuClick={() => setIsSidebarOpen(true)} />

        <main className="p-4 md:p-6 lg:p-8">
          <div className="max-w-7xl mx-auto">
            <div className="mb-6">
              <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
                Banners &amp; Hero Management
              </h1>
              <p className="text-sm text-gray-600">
                Manage promotional banners and hero section content
              </p>
            </div>

            {/* Tab Switcher */}
            <div className="bg-white rounded-lg shadow-sm p-1 mb-6 inline-flex">
              <button
                onClick={() => setActiveTab('banners')}
                className={`px-4 md:px-6 py-2 rounded-md text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  activeTab === 'banners'
                    ? 'bg-lilac-400 text-white'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                Banner Slider
              </button>
              <button
                onClick={() => setActiveTab('hero')}
                className={`px-4 md:px-6 py-2 rounded-md text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  activeTab === 'hero'
                    ? 'bg-lilac-400 text-white'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                Hero Section
              </button>
            </div>

            {/* Content */}
            <Suspense fallback={<div className="text-center py-12">Loading...</div>}>
              {activeTab === 'banners' ? <BannersGrid /> : <HeroEditor />}
            </Suspense>
          </div>
        </main>
      </div>
    </div>
  );
}
